export default __webpack_public_path__ + "static/886-40286cb148a86584ec5a83c8faf33b6c.gif";